import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApplicationInstructions from "../../../Components/ApplicationInstructions";
import { Tab, Tabs } from "react-bootstrap";
import { getCurrentUser } from "../../../Services/authService";
import { getLoggedUserDetails, loadUserDetails } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";

export default function EnrollmentSteps() {

    const [instructionShowHide, setInstructionShowHide] = useState(false);
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);

    const location = useLocation();
    const appType = location?.pathname;

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const userDetailsSelector = useSelector(getLoggedUserDetails)

    useEffect(() => {
        if (!userDetailsSelector)
            dispatch(loadUserDetails(currentUser.id));
    }, []);

    useEffect(() => {
        if (userDetailsSelector) {
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
        }
    }, [userDetailsSelector])

    const handleInstructionShowHide = () => {
        setInstructionShowHide(!instructionShowHide);
    }

    const navigate = useNavigate();

    const handleSelect = (key) => {
        navigate(key);
    };

    const allPaths = ["/Onboarding", "/ContractDocs", "/AchInfo", "/InsuranceInfo", "/OnboardingStatus", "/DynamicForm", "/PartnerCandidates", "/PartnerInvoices", "/CustomReport"];

    if (allPaths.indexOf(appType) > -1) {
        return <React.Fragment>
            <div className="mt-2">
                <button
                    type="button"
                    style={{
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "14px",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textAlign: "left"
                    }}
                    onClick={handleInstructionShowHide}
                >
                    <i
                        className="fa fa-hand-o-right text-black"
                    ></i>{" "}
                    Instructions for completing enrollment process
                </button>
            </div>
            <div className="mt-0">
                <Tabs
                    id="enrollment-tabs"
                    activeKey={appType === "/DynamicForm" ? "/Onboarding" : appType}
                    onSelect={handleSelect}
                    className="mb--2 p-2 border"
                >
                    <Tab eventKey="/Onboarding" title={<>Onboarding Form {appStatus ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    <Tab eventKey="/ContractDocs" title={<>Contract Documents {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    <Tab eventKey="/AchInfo" title={<>ACH {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    <Tab eventKey="/InsuranceInfo" title={<>Insurance {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    {<Tab eventKey="/OnboardingStatus" title={<>Check Onboarding Status {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/PartnerCandidates" title={<>List of Candidates {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/PartnerInvoices" title={<>Invoices and Payments {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/CustomReport" title={<>Reports {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                </Tabs>
            </div>
            {/* <div className="p-3 border mt-1">
                <Link
                    to="/Onboarding"
                    className={
                        (appType === "/Onboarding" || appType === "/DynamicForm")
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Onboarding Form
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/ContractDocs"
                    className={
                        appType === "/ContractDocs"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Contract Documents
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/AchInfo"
                    className={
                        appType === "/AchInfo"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    ACH Information
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/InsuranceInfo"
                    className={
                        appType === "/InsuranceInfo"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Insurance Information
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>

                <Link
                    to="/OnboardingStatus"
                    className={
                        appType === "/OnboardingStatus"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Enrollment Status

                </Link>

            </div> */}
            {instructionShowHide &&
                <ApplicationInstructions
                    instructionShowHide={instructionShowHide}
                    handleInstructionShowHide={handleInstructionShowHide}
                    entityType={""}
                ></ApplicationInstructions>}
        </React.Fragment>
    }

    return "";

}